var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSilverPodium = function SvgSilverPodium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 70,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#silverPodium_svg__a)",
    d: "M0 4a4 4 0 0 1 4-4h94v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4435C",
    d: "M0 16h98v70H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#silverPodium_svg__b)",
    d: "M0 16h98v70H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.846 55.04c.256-3.456 1.984-8.416 6.816-10.4 2.816-1.248 5.663-2.112 5.663-4.416 0-2.336-2.272-3.488-4-3.488-2.464 0-4.736.928-5.12 3.264l-3.712-.384c.608-4.16 4.544-6.432 8.832-6.432 3.84 0 7.776 2.496 7.776 6.848 0 4.448-3.52 6.048-7.968 7.776-1.888.8-3.04 2.496-3.712 4.448H58.39v3.712H41.847z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "silverPodium_svg__a",
    x1: 49.495,
    x2: 49.495,
    y1: 2.5,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9B9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "silverPodium_svg__b",
    x1: 0,
    x2: 98,
    y1: 37.462,
    y2: 37.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C6AA6"
  })))));
};
export default SvgSilverPodium;